<template>
 <content-loader
    view-box="0 0 400 285"
    :speed="2"
    primary-color="#f3f3f3"
    secondary-color="#ecebeb"
    height="400"
  >
    <rect x="37" y="8" rx="1" ry="1" width="315" height="21" /> 
    <rect x="37" y="71" rx="1" ry="1" width="315" height="21" /> 
    <rect x="37" y="135" rx="1" ry="1" width="315" height="21" /> 
    <rect x="37" y="197" rx="1" ry="1" width="315" height="21" /> 
    <circle cx="22" cy="18" r="12" /> 
    <circle cx="21" cy="146" r="12" /> 
    <circle cx="22" cy="207" r="12" /> 
    <circle cx="22" cy="82" r="12" /> 
    <rect x="37" y="255" rx="1" ry="1" width="315" height="21" /> 
    <circle cx="22" cy="265" r="12" />
  </content-loader>
</template>

<script>
import { ContentLoader } from "vue-content-loader";

export default {
    name: "FormationEditMenuLoader",
    components: { ContentLoader }
};
</script>
